module.exports = __webpack_public_path__ + "static/media/sai.619c2c69.webp";